import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['moduleContainer', 'textContainer', 'topOverlay', 'bottomLayer'],
    base: {
        moduleContainer: {
            display: 'flex',
            flexDirection: 'column',
            align: 'start',
            paddingTop: 'spacing-128',
            paddingBottom: {base: 'spacing-40', s: 'spacing-128'}
        },
        textContainer: {
            zIndex: 2,
            position: {base: 'relative', s: 'absolute'},
            paddingTop: {s: 'spacing-32'},
            paddingBottom: {base: 'spacing-40', s: 'spacing-32'},
            paddingX: {s: 'spacing-32'},
            maxWidth: {base: '100%', s: '25.5rem'}
        },
        topLayer: {
            position: 'absolute',
            zIndex: 1,
            width: '100%',
            height: 'calc(40% + 2px)', // to avoid getting a 1px black line at the bottom
            top: 0
        },
        bottomLayer: {
            position: 'absolute',
            background: 'gradient.bottom.darken-100',
            zIndex: 1,
            width: '100%',
            height: '50%',
            bottom: 0
        }
    },
    variants: {
        alignment: {
            left: {
                root: {alignItems: 'flex-start'},
                buttonGroup: {justifyContent: 'flex-start'}
            },
            center: {
                root: {alignItems: 'center'},
                buttonGroup: {justifyContent: 'center'}
            }
        },
        darken: {
            0: {topLayer: {background: 'gradient.top.darken-0'}},
            40: {topLayer: {background: 'gradient.top.darken-40'}},
            80: {topLayer: {background: 'gradient.top.darken-80'}},
            100: {topLayer: {background: 'gradient.top.darken-100'}}
        }
    }
})
